import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Col, Row, Overlay, Popover } from 'bootstrap';

import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';

import { colors as Colors } from '@shoflo-rundown/cuesheet-data-helper';

const BaseColors = [
  'pink',
  'green',
  'yellow',
  'orange',
  'brown',
  'red',
  'black',
  'blue',
  'purple',
];

const ColorOrder = [];
const HighlightColorOrder = [];
const DefaultColorRowOrder = [0, 1, 2, 3, 4, 5];
const RowHighlightColorRowOrder = [3, 4, 5, 0, 1, 2];

DefaultColorRowOrder.forEach((rowNum) => {
  BaseColors.forEach((color) => ColorOrder.push(`${color}${rowNum}`));
});

RowHighlightColorRowOrder.forEach((rowNum) => {
  BaseColors.forEach((color) => HighlightColorOrder.push(`${color}${rowNum}`));
});

const defaultPopoverId = 'colorPicker';

export { ColorOrder, HighlightColorOrder };

export default React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility')],

  displayName: 'ColorPicker',

  propTypes: {
    popoverId: React.PropTypes.string,
    icon: React.PropTypes.string,
    onColorClick: React.PropTypes.func,
    onClearClick: React.PropTypes.func,
    placement: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
    };
  },

  render() {
    return (
      <div>
        <Icon
          ref="target"
          name={this.props.icon}
          onClick={() => PopoverActions.show(this._getPopoverId())}
        />
        <Overlay
          rootClose
          show={this.state.popoverVisibility.get(this._getPopoverId())}
          onHide={() => PopoverActions.hide(this._getPopoverId())}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </div>
    );
  },

  _getPopoverNode() {
    return (
      <Popover className={'color-picker'}>
        <Col>
          <Row>
            <div className="input-color-node-wrapper">
              {this._getColorPickerOptions()}
            </div>
          </Row>
          <Row>
            <div className="text-center">
              <a onClick={this._handleClearClick}>Clear</a>
            </div>
          </Row>
        </Col>
      </Popover>
    );
  },

  _getColorPickerOptions() {
    return ColorOrder.map((color) => {
      return this._getColorCircleNode(color, Colors[color]);
    });
  },

  _getColorCircleNode(colorName, color) {
    return (
      <div
        style={{ color }}
        className={'colorpicker-option color-picker-circle-' + colorName}
      >
        <Icon name="circle" onClick={() => this._handleOnClick(colorName)} />
      </div>
    );
  },

  _handleOnClick(color) {
    this.props.onColorClick(color);
    PopoverActions.hide(this._getPopoverId());
  },

  _handleClearClick(e) {
    e.preventDefault();
    this.props.onClearClick();
    PopoverActions.hide(this._getPopoverId());
  },

  _getPopoverId() {
    return this.props.popoverId || defaultPopoverId;
  },
});
